import React, {FC, useEffect, useState, MouseEvent}  from 'react';
import { useNavigate } from 'react-router-dom';

// import MUI.
import {Avatar, Button, Grid, Typography, Link, Box, Paper, TextField, 
  MenuItem, IconButton, Checkbox, FormControlLabel} from '@mui/material';
import {Refresh as RefreshIcon } from '@mui/icons-material';

import { DatePicker } from '@mui/x-date-pickers';

// import library.
import { useFieldArray, useForm, useFormContext, Controller, FormProvider, FieldArrayWithId, ArrayPath } from 'react-hook-form';
import {useQuery,useQueryClient, QueryClient, QueryClientProvider, useMutation,useQueries, UseQueryResult } from "react-query";
import { useSnackbar } from 'notistack';
import { useTranslation  } from 'react-i18next';

import {format, parseISO, startOfMonth} from 'date-fns';

// import user Component

import EnhancedTable, {EnhancedTableProps, HeadCell,EnhancedTableToolbarProps } from '../../ui/EnhancedTable';

// import user Library.
import {IEnumerationItem} from '../configuration/model/Enumeration';

import {useUserStore} from '../../library/store'; 
import IGroupPolicy,{defaultGroupPolicy, IProductByGroupPolicy}  from './model/GroupPolicy';
import IBankPolicy, {IBankPolicySearch} from './model/BankPolicy';

import useBankPolicyService from './service/BankPolicy';
import useGroupPolicyService from './service/GroupPolicy';
import useEnumerationService from '../configuration/service/Enumeration';
import IBankPerson from './model/BankPerson';

interface BankPolicyListFormProps {
  onRowDoubleClick? : (event: React.MouseEvent<unknown>, bankPolicy: IBankPolicy) => void
}

const BankPolicyListForm: FC<BankPolicyListFormProps> = (props :BankPolicyListFormProps) => {

  const {onRowDoubleClick} = props;

  const { setCurrentEntity, currentUser, setCurrentObjectDataDef, setCurrentObjectKey, setCurrentObjectsKey} = useUserStore();
  const {language: lg} = currentUser;

  const {getUserGroupPoliciesList, getUserAgenciesList, getGroupPolicyProductsList} = useGroupPolicyService();
  const {getEnumerationItemsList} = useEnumerationService();

  const {getBankPoliciesList} = useBankPolicyService();

  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const [headPolicyCells, setHeadPolicyCells]  = useState<HeadCell<IBankPolicy>[]>([
    {id:'policyID', label : 'Policy ID',  display: true, type: 'string'},
    
    {id:lg.startsWith('fr')?'lastName':'firstName', label : t(lg.startsWith('fr')?'Last Name':'First Name'),  display: true, type: 'string'},
    {id:lg.startsWith('fr')?'firstName':'lastName', label : t(lg.startsWith('fr')?'First Name':'Last Name'),  display: true, type: 'string'},  
    
    // {id:lg.startsWith('fr')?'payorLastName':'payorFirstName', label : t(lg.startsWith('fr')?'Payor Last Name':'Payor First Name'),  display: true, type: 'string'},
    // {id:lg.startsWith('fr')?'payorFirstName':'payorLastName', label : t(lg.startsWith('fr')?'Payor First Name':'Payor Last Name'),  display: true, type: 'string'},  
    
    {id:'effectiveDate', label : t('EffectiveDate'),  display: true, type: 'date'}, 
    {id:'expirationDate', label : t('ExpirationDate'),  display: true, type: 'date'},   
    {id:'productName', label : t('Product'),  display: true, type: 'string'}, 
    {id:'capital', label : t('Capital'),  display: true, type: 'numeric'},
    {id:'netPremium', label : t('Net_Premium'),  display: true, type: 'numeric'},
    ]);
  
  // const [personNameNIC, setPersonNameNIC] = useState('');
  // const [payorPersonNameNIC, setPayorPersonNameNIC] = useState('');
  // const [effectiveYear, setEffectiveYear] = useState(0);
  // const [effectiveMonth, setEffectiveMonth] = useState(0);

  const [policiesSelected, setPoliciesSelected] = useState<number[]>([]);

  const {getValues, register, watch, control} = useForm<IBankPolicySearch>( {defaultValues:{ 
    groupPolicyID: 0, productCode: '', agencyCode: '', policyStatus: '', isPolicyTransmited: false, 
    personNameNIC: '', payorPersonNameNIC: '', effectiveDateStart: startOfMonth(new Date()), effectiveDateEnd: new Date()}} );

  const isValidRequest = () : boolean => {
    const {groupPolicyID, policyStatus, agencyCode, productCode, payorPersonNameNIC, personNameNIC} = getValues();
    
    return payorPersonNameNIC !== '' || personNameNIC !== '' || groupPolicyID > 0 || 
      policyStatus !== '' || productCode !== '' || agencyCode !== '';
  }

  // const {isSuccess: isBankPoliciesSuccess, status: bankPoliciesStatus,refetch: refetchBankPolicies,data: bankPolicies} = 
  //     useQuery<IBankPolicy[]>(['BankPolicies', 
  //     getValues().groupPolicyID, getValues().productCode, getValues().agencyCode, getValues().policyStatus, getValues().isPolicyTransmited,
  //      getValues().effectiveDateStart.toISOString(), getValues().effectiveDateEnd.toISOString(),getValues().personNameNIC, getValues().payorPersonNameNIC  ], 
  //       () => getBankPoliciesList( getValues() ),
  //     {enabled: isValidRequest() } );

  const [bankPolicies, setBankPolicies] = useState<IBankPolicy[]>([]);

  const {isSuccess: isGroupPolicyProductsSuccess, status: groupPolicyProductsStatus,data: groupPolicyProducts} = 
        useQuery<IProductByGroupPolicy[]>("groupPolicyProducts", getGroupPolicyProductsList);

  const [currentProducts, setCurrentProducts] = useState<IProductByGroupPolicy[]>(groupPolicyProducts || []);

  const {isSuccess: isUserGroupPoliciesSuccess, status: userGroupPoliciesStatus,data: userGroupPolicies} = 
        useQuery<IGroupPolicy[]>("userGroupPolicies",getUserGroupPoliciesList);

  const [ 
    {isSuccess: isUserAgenciesSuccess, status: userAgenciesStatus,data : userAgencies },
    {isSuccess: isPolicyStatusSuccess, status: policyStatusStatus,data: allPolicyStatus},
  ] = useQueries([
      {queryKey: ['userAgencies', currentUser.userName], queryFn: getUserAgenciesList},
      {queryKey: ['policyStatus'], queryFn: () => getEnumerationItemsList('POLICY_STT')},
      
    ]) as UseQueryResult<IEnumerationItem[]>[];

  const watchGroupPolicy = watch("groupPolicyID");
   
    // useQuery<IBankPerson>(['Product', ], () => getBankPersonsList('', '', '', '', 0,0,), 
    //     {enabled: ('currentProductCode' !== '' /*&& currentProduct.productCode !== currentProductCode*/  ) } );
    const defaultHandleRowDoubleClick = (event: React.MouseEvent<unknown>, bankPolicy: IBankPolicy) => {
      const selectPolicyID = bankPolicy.policyID || 0;     

      if(selectPolicyID > 0)         
        navigate(`/bankPolicy/${selectPolicyID}`);          
    }

  

  useEffect( () => {
    setCurrentEntity(t('BankPolicyList'));
    setCurrentObjectDataDef('00115');
    setCurrentObjectKey( '@UnivList@');
  }, [] );

  useEffect(() => {    
    const data = getValues();
    const groupPolicyID = data.groupPolicyID || 0;       
    // setCurrentGroupPolicyID(groupPolicyID);

    if(groupPolicyProducts && groupPolicyID && groupPolicyID > 0) {
      const arr = groupPolicyProducts.filter(x => x.groupPolicyID === groupPolicyID);
      setCurrentProducts([...arr]);    
    }
  }, [watchGroupPolicy]);

  useEffect( () => {
    setCurrentObjectsKey( policiesSelected.map(policyID => policyID.toString()) );
    //console.log(policiesSelected.map(policyID => policyID.toString()));
  }, [policiesSelected] );
  

  const handleRefreshList = async (event : any) => {
    // const { personNameNIC, payorPersonNameNIC } = getValues();
    
    const arr = await getBankPoliciesList(getValues());
    setBankPolicies(arr);
  }

  const listData = async (event: MouseEvent<HTMLButtonElement>) => {
    handleRefreshList(event);
  }
  

    return (
      <>
        <Grid container component="main" sx={{  width: '100%' }} alignItems="flex-start">
          <Grid item xs={12}  component={Paper} elevation={0} square>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }} >
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <Controller name='groupPolicyID' control={control} defaultValue={0}
                      render={ ({field: {onChange, value}}) => (
                        <TextField select onChange={onChange} value={value} sx={{width:'calc(25% - 8px)'}} id="groupPolicyID" label={t('Contract')}>
                        {userGroupPolicies && userGroupPolicies.map( 
                          (ei,idx) => <MenuItem key={ei.groupPolicyID} value={ei.groupPolicyID}>{ei.groupContractName}</MenuItem> )
                        }
                        </TextField>
                      )}
                  />
                  <Controller name='productCode' control={control} defaultValue=''
                      render={ ({field: {onChange, value}}) => (
                        <TextField select required onChange={onChange} value={value} sx={{width:'calc(25% - 8px)'}} id="productCode" label={t('Product')}>
                        {currentProducts && currentProducts.map( 
                          (prd,idx) => <MenuItem key={prd.productCode} value={prd.productCode}>{prd.productName}</MenuItem> )
                        }
                        </TextField>
                      )}
                  />
                  <Controller name='agencyCode' control={control} defaultValue=''
                      render={ ({field: {onChange, value}}) => (
                        <TextField select required onChange={onChange} value={value} sx={{width:'calc(25% - 8px)'}} id="agencyCode" label={t('Agency')}>
                        {userAgencies && userAgencies.map( 
                          (ei,idx) => <MenuItem key={ei.enumerationItemCode} value={ei.enumerationItemCode}>{ei.enumerationItemName}</MenuItem> )
                        }
                        </TextField>
                      )}
                  />
                  <Controller name='policyStatus' control={control} 
                      render={ ({field: {onChange, value}}) => (
                        <TextField select onChange={onChange} value={value} sx={{width:'calc(25% - 8px)'}} id="policyStatus" label={t('Status')} >
                        {allPolicyStatus && allPolicyStatus.map( 
                          (ei,idx) => <MenuItem key={ei.enumerationItemCode} value={ei.enumerationItemCode}>{ei.enumerationItemName}</MenuItem> )
                        }
                        </TextField>
                      )}
                  />

                  
                                    
                  <Button id='btnList' onClick={listData} sx={ {display:'none'}}  /> 
                </Box>  
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <TextField  sx={{width:'calc(25% - 8px)'}} id="personNameNIC" label="First Name" {...register('personNameNIC')} />     
                  <TextField  sx={{width:'calc(25% - 8px)'}} id="payorPersonNameNIC" label="Last Name" {...register('payorPersonNameNIC')} /> 
                  
                  <Controller control={control}
                    name='effectiveDateStart' 
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <DatePicker label={t('Eff. Date Start')}
                        onChange={onChange}                        
                        value={value}
                        renderInput={(params) => <TextField {...params} sx={{width:'calc(10% - 8px)'}} />}
                      /> )}
                  />
                  <Controller control={control}
                    name='effectiveDateEnd' 
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <DatePicker label={t('Eff. Date End')}
                        onChange={onChange}                        
                        value={value} 
                        renderInput={(params) => <TextField {...params} sx={{width:'calc(10% - 8px)'}} />}
                      /> )}
                  />

                  <FormControlLabel sx={{width:'calc(10% - 8px)'}}
                    control={
                      <Controller
                          name='isPolicyTransmited'
                          control={control}
                          render={({ field: {onChange, value} }) => <Checkbox onChange={onChange} checked={value} />}
                        />  }
                      label={t('Transmited ?')}
                  />
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >                      
                  { <EnhancedTable<IBankPolicy> headCells={headPolicyCells} rows={bankPolicies || []} order='asc' orderBy='policyID'
                    title='Liste Polices...' objKey='policyID' //onRowSelected={handleRoleItemSelected}
                    onRowDoubleClick={onRowDoubleClick?onRowDoubleClick:defaultHandleRowDoubleClick}
                    stateSelected={[policiesSelected, setPoliciesSelected]}
                    toolbarActions={[ { toolTip: 'Refresh...', onClickIcon: handleRefreshList ,icon: RefreshIcon } ]} />   }   
                               
                </Box>     
              </Box>
          </Grid>         
        </Grid>
      </>
    );
  }
  
  export default BankPolicyListForm;